import { resolveAcademicYear } from "years";

function apiBaseUrl() {
  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const configuredUrl = process.env.REACT_APP_VISITOR_API_URL;

  return [
    configuredUrl,
    `${publicUrl}/api/visitor-counts.php`,
    `${publicUrl}/public/api/visitor-counts.php`,
  ].filter(Boolean);
}

export async function getVisitorCounts({ scope = "site", target, year }) {
  const params = new URLSearchParams({
    scope,
    year: resolveAcademicYear(year),
  });

  if (target) {
    params.set("target", target);
  }

  try {
    for (const baseUrl of apiBaseUrl()) {
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 2500);

      try {
        const response = await fetch(`${baseUrl}?${params.toString()}`, {
          headers: { Accept: "application/json" },
          signal: controller.signal,
        });

        if (!response.ok) continue;

        const payload = await response.json();
        if (payload?.code === 200) return payload.data;
      } catch (error) {
        // Try the next candidate URL.
      } finally {
        window.clearTimeout(timeoutId);
      }
    }

    return null;
  } catch (error) {
    return null;
  }
}

export async function updateVisitorCounts({
  scope = "site",
  target,
  year,
  amount = 1,
}) {
  const body = {
    scope,
    year: resolveAcademicYear(year),
    amount,
  };

  if (target) {
    body.target = target;
  }

  try {
    for (const baseUrl of apiBaseUrl()) {
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 2500);

      try {
        const response = await fetch(baseUrl, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
          signal: controller.signal,
        });

        if (!response.ok) continue;

        const payload = await response.json();
        if (payload?.code === 200) return payload.data;
      } catch (error) {
        // Try the next candidate URL.
      } finally {
        window.clearTimeout(timeoutId);
      }
    }

    return null;
  } catch (error) {
    return null;
  }
}

export async function mergeVisitorCounts(payload, options) {
  if (payload?.code !== 200 || !payload?.data) return payload;

  const counts = options?.incrementVisitor
    ? await updateVisitorCounts(options)
    : await getVisitorCounts(options);

  if (!counts) return payload;

  return {
    ...payload,
    data: {
      ...payload.data,
      visitor: counts.visitor,
      visitor_of_year: counts.visitor_of_year,
    },
  };
}
